import * as R from 'ramda';
import React, {Component} from 'react';
import axios from 'axios';
import {Modal} from 'react-bootstrap';
import Bluebird from 'bluebird';

import TagsApiClient from 'js/tags_api_client';
import KeyValueTagsApiClient from 'js/key_value_tags_api_client';
import CampaignsApiClient from 'js/campaigns_api_client';
import LoadingSpinner from 'js/components/loading_spinner/index';
import AdvancedFilters from '../../publisher_leads/advanced_filters';

export default class AdvancedFiltersModal extends Component {
    constructor() {
        super();

        this.state = {};
    }

    componentDidMount() {
        this.fetchFilters();
    }

    fetchFilters = async () => {
        const [tags, keyValueTags, allCampaigns] = await Bluebird.all([
            TagsApiClient.allTagNames(),
            KeyValueTagsApiClient.allTagNames(),
            CampaignsApiClient.index()
        ]);

        this.setState({tags, key_value_tags: keyValueTags, allCampaigns});
    };

    render() {
        const {
            showNotification,
            urls,
            advancedFiltersModal,
            handleAdvancedFiltersModalHide,
            constants
        } = this.props;

        const {tags, key_value_tags, allCampaigns} = this.state;

        if (R.any(R.isEmpty)([tags, key_value_tags, allCampaigns])) {
            return (
                <div className="text-center">
                    <LoadingSpinner additionalClasses="fa-3x" />
                </div>
            );
        }

        const saveFilter = filter =>
            axios
                .post(urls.updateCampaignFilterUrl, {filter})
                .then(response => showNotification('Saved filter successfully.'))
                .catch(response => {
                    const {
                        data: {error}
                    } = response;
                    const message = error || 'Invalid response received. Please try again!';
                    return showNotification({
                        message,
                        type: 'error'
                    });
                });

        const {show} = advancedFiltersModal;

        return (
            <Modal show={show} onHide={handleAdvancedFiltersModalHide}>
                <AdvancedFilters
                    searchTypeEnum={constants.searchTypeEnum}
                    isCampaignFilter
                    onFiltersApplied={saveFilter}
                    getCampaignFilterDataUrl={urls.getCampaignFilterDataUrl}
                    brandsApiUrl={urls.brandsApiUrl}
                    campaignsApiUrl={urls.campaignsApiUrl}
                    campaignFuzzySearchUrl={urls.campaignFuzzySearchUrl}
                    filtersApiUrl={urls.getCrmFiltersForCampaignUrl}
                    tags={tags}
                    key_value_tags={key_value_tags}
                    allCampaigns={allCampaigns}
                />
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./execution/shared_components/advanced_filters_modal.js